import React from "react";
import { Link } from "react-router-dom";
import { isAdminAccount, isTrainee } from "../../helpers/Helpers";

/**
 * User dropdown menu component displayed when clicking on the user avatar
 * Provides links to user account pages and logout functionality
 */
const UserDropdownMenu = ({ toggleUserMenu, LogOut, checkCurrentPageUrl }) => {
  const showLink = !isTrainee();
  const showNutritionHistory =
    localStorage.getItem("show_nutrition") === "1" ||
    localStorage.getItem("show_nutrition") === "true";
  return (
    <div className="user-dropdown-menu">
      <Link
        to={isAdminAccount() ? "/dashboard" : "/profile"}
        onClick={() => {
          localStorage.setItem(
            "activeTab",
            isAdminAccount() ? "dashboard" : "profile"
          );
          toggleUserMenu();
        }}
      >
        Dashboard
      </Link>
      {showLink && (
        <Link to="/messages" onClick={() => toggleUserMenu()}>
          Messages
        </Link>
      )}
      <div className="section-divider">
        <span className="section-label">MY ACCOUNT</span>
      </div>
      {showLink && (
        <Link to="/clients" onClick={() => toggleUserMenu()}>
          My Clients
        </Link>
      )}
      {showLink && (
        <Link to="/my-events" onClick={() => toggleUserMenu()}>
          Manage Events
        </Link>
      )}
      <Link to="/my-competitions" onClick={() => toggleUserMenu()}>
        {showLink ? "Manage Competitions" : "Competitions"}
      </Link>
      {showLink && (
        <Link to="/my-events?tab=tickets" onClick={() => toggleUserMenu()}>
          My Tickets
        </Link>
      )}
      {showNutritionHistory && (
        <Link to="/track-diet" onClick={() => toggleUserMenu()}>
          Nutrition History
        </Link>
      )}
      {showLink && (
        <Link to="/all-groups" onClick={() => toggleUserMenu()}>
          My Groups
        </Link>
      )}

      <Link
        to="/login"
        className="logout-link"
        onClick={() => {
          checkCurrentPageUrl();
          LogOut();
          toggleUserMenu();
        }}
      >
        Log out
      </Link>
    </div>
  );
};

export default UserDropdownMenu;
